import ProposalStatus from "../../../../../Shared/ProposalStatus/ProposalStatus";
import {CurrentModalNameEnum} from "../../../../../Enums/CurrentModalNameEnum";
import deleteIcon from "../../../../../assets/icons/delete-red-icon.svg";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import React, {FC, useEffect} from "react";
import {FormikProps} from "formik";
import UseModal from "../../../../../Services/CustomHooks/useModal";
import CreateProposalBody from "../../CreateProposal/CreateProposalModal/CreateProposalBody/CreateProposalBody";
import {useSelector} from "react-redux";
import RootState from "../../../../../Types/states/RootState";
import {ModalHeadersEnum} from "../../../../../Enums/ModalHeadersEnum";
import DesktopModalHeader from "../../../ModalComponents/ModalHeader/DesktopModalHeader";
import {CreateProposalFormik} from "src/Types/states/modal/CreateProposalFormik";
import styles from "./EditProposalModal.module.scss"
import classNames from "classnames";
import {Button} from "@devapo/devapo-ui";

interface EditProposalModalProps {
    formik: FormikProps<CreateProposalFormik & { role: string }>,
    result?: unknown
}

const EditProposalModal: FC<EditProposalModalProps> = (props) => {

    const {formik, result} = props;
    const {changeModalHistory} = UseModal()
    const {currentProposal} = useSelector((state: RootState) => state.modalPopup)

    useEffect(() => {
        loadCurrentProposalToFormik()
    }, [currentProposal]);

    const loadCurrentProposalToFormik = () => {
        formik.setFieldValue("employee", currentProposal.employee)
        formik.setFieldValue("requester", currentProposal.requester)
        formik.setFieldValue("absenceType", currentProposal.absenceType)
        formik.setFieldValue("holidayType", currentProposal.holidayType ? currentProposal.holidayType : null)
        formik.setFieldValue("absenceStartDate", currentProposal.absenceStartDate)
        formik.setFieldValue("absenceFinishDate", currentProposal.absenceFinishDate)
        formik.setFieldValue("description", currentProposal.description ? currentProposal.description : null)
        formik.setFieldValue("replacement", currentProposal.replacement ? currentProposal.replacement : null)
    }

    return (
        <form
            className={styles.modal_block}
            onSubmit={formik.handleSubmit}
        >

            <DesktopModalHeader
                header={ModalHeadersEnum.EDIT_PROPOSAL}
                startDate={currentProposal.absenceStartDate}
                endDate={currentProposal.absenceFinishDate}
                absenceType={currentProposal.absenceType}
            >
                <ProposalStatus proposalStatus={currentProposal.proposalStatus}/>
            </DesktopModalHeader>

            <div className={styles.body}>
                <CreateProposalBody formik={formik} result={result}/>
            </div>

            <div className={styles.footer} >
                <Button
                    text={"Odwołaj"}
                    icon={<img src={deleteIcon} alt="delete icon"/>}
                    onClick={() => changeModalHistory(CurrentModalNameEnum.CANCEL_PROPOSAL)}
                    type={"button"}
                    color={"warning"}
                    withBackground={false}
                    withBorder={true}
                    className={styles.cancel_button}
                />
                <Button
                    icon={<CheckCircleOutlineOutlinedIcon htmlColor={"white"} />}
                    text={"Zapisz zmiany"}
                    type={"submit"}
                    color={"success"}
                    className={classNames({
                        [styles.disabled_submit]: !(formik.isValid && formik.dirty)
                    })}
                />
            </div>
        </form>
    )
}

export default EditProposalModal